<!-- 
    a single navigation item
 -->
<ion-menu-toggle [ngClass]="paneClass" auto-hide="false">
    <a
        *ngIf="page.url"
        [href]="'/' + page.url"
        (click)="$event.preventDefault(); routeToPage(page)"
        class="sidebar__item sidebar__item-link"
        [ngClass]="{selected: getActiveRouteClass(page), 'sidebar__item--sub': page.isSubItem}">
        <svg *ngIf="displayIcon" class="sidebar__item-icon">
            <use attr.xlink:href="/assets/icon/sprite.svg#{{ page.icon }}"></use>
        </svg>
        <span class="sidebar__item-label">{{ page.title }}</span>
    </a>
    <ion-item
        *ngIf="!page.url"
        (click)="routeToPage(page)"
        lines="none"
        detail="false"
        class="sidebar__item"
        [ngClass]="{selected: getActiveRouteClass(page), 'sidebar__item--sub': page.isSubItem}">
        <svg *ngIf="displayIcon" class="sidebar__item-icon" slot="start">
            <use attr.xlink:href="/assets/icon/sprite.svg#{{ page.icon }}"></use>
        </svg>
        <ion-label class="sidebar__item-label">{{ page.title }}</ion-label>
    </ion-item>
</ion-menu-toggle>
